module.exports = {
          srcSet: __webpack_public_path__ + "public/images/0768158c352d1bb9776f68be6aa59205-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/0768158c352d1bb9776f68be6aa59205-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/0768158c352d1bb9776f68be6aa59205-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/0768158c352d1bb9776f68be6aa59205-1774.jpg"},
          
          width: 1774,
          height: 887
        }